module.exports = __webpack_public_path__ + "pc/img/brand05.92c89473.png";